import { actions } from "./action-list";

export function reportTypesFetched(value) {
  return {
    type: actions.FETCH_REPORTS_MODULE.FETCH_REPORTS_MODULE_TYPES,
    value,
  };
}

export function updateSelectedReportType(value) {
  return {
    type: actions.FETCH_REPORTS_MODULE.SELECTED_REPORTS_MODULE_TYPE,
    value,
  };
}

export function userGeneratedReportsFetched(value) {
  return {
    type: actions.FETCH_REPORTS_MODULE.FETCH_USER_GENERATED_REPORTS,
    value,
  };
}

export function getLinkAndDownloadReport(storageKey) {
  return {
    type: actions.FETCH_REPORTS_MODULE.FETCH_LINK_AND_DOWNLOAD_REPORT,
    value: storageKey,
  };
}
